/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceStatusFilter } from './PriceStatusFilter';
import {
    PriceStatusFilterFromJSON,
    PriceStatusFilterFromJSONTyped,
    PriceStatusFilterToJSON,
    PriceStatusFilterToJSONTyped,
} from './PriceStatusFilter';
import type { ProductStatusFilter } from './ProductStatusFilter';
import {
    ProductStatusFilterFromJSON,
    ProductStatusFilterFromJSONTyped,
    ProductStatusFilterToJSON,
    ProductStatusFilterToJSONTyped,
} from './ProductStatusFilter';

/**
 * 
 * @export
 * @interface CreatePriceExperienceRequest
 */
export interface CreatePriceExperienceRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreatePriceExperienceRequest
     */
    validFromDate: Date;
    /**
     * 
     * @type {number}
     * @memberof CreatePriceExperienceRequest
     */
    priceUnitCategoryId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePriceExperienceRequest
     */
    priceUnitIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreatePriceExperienceRequest
     */
    productIds: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePriceExperienceRequest
     */
    themeIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePriceExperienceRequest
     */
    groupIds: Array<string>;
    /**
     * 
     * @type {ProductStatusFilter}
     * @memberof CreatePriceExperienceRequest
     */
    productStatus: ProductStatusFilter;
    /**
     * 
     * @type {PriceStatusFilter}
     * @memberof CreatePriceExperienceRequest
     */
    priceStatus: PriceStatusFilter;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePriceExperienceRequest
     */
    onlyZeroPrices: boolean;
}

/**
 * Check if a given object implements the CreatePriceExperienceRequest interface.
 */
export function instanceOfCreatePriceExperienceRequest(value: object): value is CreatePriceExperienceRequest {
    if (!('validFromDate' in value) || value['validFromDate'] === undefined) return false;
    if (!('productIds' in value) || value['productIds'] === undefined) return false;
    if (!('themeIds' in value) || value['themeIds'] === undefined) return false;
    if (!('groupIds' in value) || value['groupIds'] === undefined) return false;
    if (!('productStatus' in value) || value['productStatus'] === undefined) return false;
    if (!('priceStatus' in value) || value['priceStatus'] === undefined) return false;
    if (!('onlyZeroPrices' in value) || value['onlyZeroPrices'] === undefined) return false;
    return true;
}

export function CreatePriceExperienceRequestFromJSON(json: any): CreatePriceExperienceRequest {
    return CreatePriceExperienceRequestFromJSONTyped(json, false);
}

export function CreatePriceExperienceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePriceExperienceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'validFromDate': (new Date(json['validFromDate'])),
        'priceUnitCategoryId': json['priceUnitCategoryId'] == null ? undefined : json['priceUnitCategoryId'],
        'priceUnitIds': json['priceUnitIds'] == null ? undefined : json['priceUnitIds'],
        'productIds': json['productIds'],
        'themeIds': json['themeIds'],
        'groupIds': json['groupIds'],
        'productStatus': ProductStatusFilterFromJSON(json['productStatus']),
        'priceStatus': PriceStatusFilterFromJSON(json['priceStatus']),
        'onlyZeroPrices': json['onlyZeroPrices'],
    };
}

export function CreatePriceExperienceRequestToJSON(json: any): CreatePriceExperienceRequest {
    return CreatePriceExperienceRequestToJSONTyped(json, false);
}

export function CreatePriceExperienceRequestToJSONTyped(value?: CreatePriceExperienceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validFromDate': (formatDateOnly(value['validFromDate'])),
        'priceUnitCategoryId': value['priceUnitCategoryId'],
        'priceUnitIds': value['priceUnitIds'],
        'productIds': value['productIds'],
        'themeIds': value['themeIds'],
        'groupIds': value['groupIds'],
        'productStatus': ProductStatusFilterToJSON(value['productStatus']),
        'priceStatus': PriceStatusFilterToJSON(value['priceStatus']),
        'onlyZeroPrices': value['onlyZeroPrices'],
    };
}

